var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper scroll-y custom-scrollbar view-error404"},[_c('div',{staticClass:"padding text-center"},[_c('h2',[_vm._v("Błąd 404")]),_c('p',[_vm._v("Strona o podanym adresie nie istnieje.")])])])
}]

export { render, staticRenderFns }